import { inject, DestroyRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

export let keyCloakCost: number;

export function setKeycloakCost(val: number) {
  keyCloakCost = val;
}

export function untilDestroyRef() {
  // Use when closing manual subscriptions in !- Angular Components -!
  const subject = new Subject();

  inject(DestroyRef).onDestroy(() => {
    subject.next(true);
    subject.complete();
  });

  return <T>() => takeUntil<T>(subject.asObservable());
}
